import { defineMessages } from 'react-intl-next';

export default defineMessages({
	expandButton: {
		id: 'expandableItem.expandButton',
		defaultMessage: 'Expand',
		description: 'Label for expand button',
	},
	collapseButton: {
		id: 'expandableItem.collapseButton',
		defaultMessage: 'Collapse',
		description: 'Label for collapse button',
	},
});
